var map = {
	"./global-dev": "bea3",
	"./global-dev.js": "bea3",
	"./global-pro": "fcbc",
	"./global-pro.js": "fcbc",
	"./global-test": "c2e5",
	"./global-test.js": "c2e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ab9";